import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=27e456bd&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=ts"
export * from "./LegalNotice.vue?vue&type=script&lang=ts"
import style0 from "./LegalNotice.vue?vue&type=style&index=0&id=27e456bd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e456bd",
  null
  
)

export default component.exports